module.exports = __webpack_public_path__ + "static/media/lock-mailer-dieline.fd732bcc.svg";